import React, { useState } from "react";
import { Link, navigate } from "gatsby";
import smoothScrollTo from "../helpers/smoothScrollTo";
import BurgerBottomImage from "../images/burger-bottom.png";

const Burger = ({ pathname, headerData }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleTriggerClick = () => {
    setIsOpen(!isOpen);
  };

  const handleScrollClick = (target) => {
    setIsOpen(false);
    if (pathname === "/") {
      const targetEl = document.querySelector(`.Target-${target}`);
      if (targetEl) {
        smoothScrollTo(targetEl);
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const targetEl = document.querySelector(`.Target-${target}`);
        if (targetEl) {
          smoothScrollTo(targetEl);
        }
      }, 1500);
    }
  };

  const links = headerData?.links || [];
  const ctaVisible = headerData?.cta_visible === true;
  const ctaLabel = headerData?.cta_label || "";
  const ctaUrl = headerData?.cta_url || "";

  return (
    <div className={`Burger ${isOpen ? "isOpen" : ""}`}>
      <div className="Burger__Trigger" onClick={handleTriggerClick}>
        <div className="Burger__TriggerGlow"></div>
      </div>
      <div className="Burger__Container">
        <div className="Burger__Nav">
          <ul className="Burger__Links">
            <li
              className="Burger__Link"
              onClick={() => handleScrollClick("Hero")}
            >
              Home
            </li>
            {links.map((link, i) => (
              <li className="Burger__Link" key={i}>
                {link.type === "scroll" ? (
                  <span onClick={() => handleScrollClick(link.url)}>
                    {link.label}
                  </span>
                ) : link.is_external ? (
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link to={link.url} onClick={() => setIsOpen(false)}>
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          {ctaVisible && (
            <div className="Burger__CtaTickets">
              <a
                href={ctaUrl}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg
                  className="Burger__CtaTicketsArrow"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M-2.11117e-07 3.6731L11.3462 3.67309M11.3462 3.67309L8.16421 0.491113M11.3462 3.67309L8.16421 6.85507"
                    stroke="#928975"
                  />
                </svg>
                <span className="Burger__CtaTicketsLabel">{ctaLabel}</span>
              </a>
            </div>
          )}
        </div>
        <img className="Burger__BurgerImage" src={BurgerBottomImage} />
      </div>
    </div>
  );
};

export default Burger;
